var $5f637eb0c91d0f64$exports = {};
$5f637eb0c91d0f64$exports = {
    "dismiss": `Schlie\xdfen`
};


export {$5f637eb0c91d0f64$exports as default};
//# sourceMappingURL=de-DE.mjs.map
